"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHashFromMobileAppLink = exports.ParseHashService = void 0;
var qs = require("qs");
var error_service_1 = require("./error-service");
var ParseHashService = /** @class */ (function () {
    function ParseHashService(tokenVerifierService) {
        var _this = this;
        /**
         * Modified from https://auth0.github.io/auth0.js/web-auth_index.js.html#line181
         * Parse the url hash and extract the Auth response from an Auth flow passed in from the mobile application
         *
         * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
         * by the `/.well-known/jwks.json` endpoint of your account.
         * Tokens signed with other algorithms will not be accepted.
         */
        this.parseHashFromMobile = function (options, cb) {
            // let parsedQs: qs.ParsedQs;
            var err;
            var parsedQs = qs.parse(options.hash);
            if (parsedQs.hasOwnProperty('error')) {
                err = (0, error_service_1.buildErrorResponse)(parsedQs.error, parsedQs.error_description);
                if (parsedQs.state) {
                    err.state = parsedQs.state;
                }
                return cb(err);
            }
            if (!parsedQs.hasOwnProperty('access_token') && !parsedQs.hasOwnProperty('id_token') && !parsedQs.hasOwnProperty('refresh_token')) {
                return cb(null, null);
            }
            var responseTypes = (options.responseType || '').split(' ');
            if (responseTypes.length > 0 && responseTypes.indexOf('token') !== -1 && !parsedQs.hasOwnProperty('access_token')) {
                return cb((0, error_service_1.buildErrorResponse)('invalid_hash', 'response_type contains `token`, but the parsed hash does not contain an `access_token` property'));
            }
            if (responseTypes.length > 0 && responseTypes.indexOf('id_token') !== -1 && !parsedQs.hasOwnProperty('id_token')) {
                return cb((0, error_service_1.buildErrorResponse)('invalid_hash', 'response_type contains `id_token`, but the parsed hash does not contain an `id_token` property'));
            }
            return _this.validateAuthenticationResponse(options, parsedQs, cb);
        };
        this.tokenVerifier = tokenVerifierService;
    }
    ParseHashService.prototype.parseHashFromMobileAsync = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.parseHashFromMobile(options, function (err, data) {
                if (err !== null)
                    reject(err);
                else
                    resolve(data);
            });
        });
    };
    /**
     * Validates an Auth response passed in from the mobile application.
     *
     * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
     * by the `/.well-known/jwks.json` endpoint of your account.
     * Tokens signed with other algorithms will not be accepted.
     */
    ParseHashService.prototype.validateAuthenticationResponse = function (options, parsedHash, cb) {
        var _this = this;
        options.__enableIdPInitiatedLogin = options.__enableIdPInitiatedLogin || options.__enableImpersonation;
        var appState = options.state || null;
        var callback = function (err, payload) {
            if (err) {
                return cb(err);
            }
            return cb(null, _this.buildParseHashResponse(parsedHash, appState, payload));
        };
        if (!parsedHash.id_token) {
            return callback(null, null);
        }
        return this.tokenVerifier.validateToken(parsedHash.id_token, function (validationError, payload) {
            if (!validationError) {
                if (!parsedHash.access_token) {
                    return callback(null, payload);
                }
                // id_token's generated by non-oidc applications don't have at_hash
                if (!payload.at_hash) {
                    return callback(null, payload);
                }
                // here we're absolutely sure that the id_token's alg is RS256
                // and that the id_token is valid, so we can check the access_token
                return _this.tokenVerifier.validateAccessToken(parsedHash.access_token, payload.at_hash, function (err) {
                    if (err) {
                        return callback((0, error_service_1.invalidTokenError)(err.message));
                    }
                    return callback(null, payload);
                });
            }
            if (validationError.error !== 'invalid_token' ||
                (validationError.errorDescription &&
                    validationError.errorDescription.indexOf('Nonce (nonce) claim value mismatch in the ID token') > -1)) {
                return callback(validationError);
            }
            // if it's an invalid_token error, decode the token
            var decodedToken = _this.tokenVerifier.decode(parsedHash.id_token);
            // if the alg is not HS256, return the raw error
            if (decodedToken.header.alg !== 'HS256') {
                return callback(validationError);
            }
            return callback((0, error_service_1.buildErrorResponse)('unsupported_alg', 'HS256 not supported'));
        });
    };
    ParseHashService.prototype.buildParseHashResponse = function (qsParams, appState, token) {
        return {
            accessToken: qsParams.access_token || null,
            idToken: qsParams.id_token || null,
            idTokenPayload: token || null,
            appState: appState || null,
            refreshToken: qsParams.refresh_token || null,
            state: qsParams.state || null,
            expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
            tokenType: qsParams.token_type || null,
            scope: qsParams.scope || null,
        };
    };
    return ParseHashService;
}());
exports.ParseHashService = ParseHashService;
var convertHashFromMobileAppLink = function (hashFromMobileApp) {
    var _window = window;
    var hashStr = hashFromMobileApp === undefined ? _window.location.hash : hashFromMobileApp;
    hashStr = hashStr.substring(hashStr.indexOf('#acct=') + 1);
    // hashStr = hashStr.replace(/^#?\/?/, '');
    var parsedQs = qs.parse(hashStr);
    if (!parsedQs.acct || !parsedQs.idt || (parsedQs.plat !== 'i' && parsedQs.plat !== 'a')) {
        return { hash: null, platform: null };
    }
    return { hash: "access_token=".concat(parsedQs.acct, "&id_token=").concat(parsedQs.idt, "&state=").concat('s'), platform: parsedQs.plat };
};
exports.convertHashFromMobileAppLink = convertHashFromMobileAppLink;
